<template>
  <div>
    <Navbar />
    <div class="flex flex-col px-4 lg:px-16 gap-2 lg:gap-4">
      <div class="flex">
        <div
          @click="selectStoryQuests"
          class="w-1/2 cursor-pointer flex items-center justify-center pb-1 lg:pb-2 relative"
        >
          <Typography
            size="main-l"
            :class="{ 'opacity-50 ': tabs.storyQuests == false }"
            >Story Quests</Typography
          >
          <div
            :class="{
              'w-full h-1 bg-neutral-600  bottom-0 absolute': true,
              '!bg-primary h-1': tabs.storyQuests == true,
            }"
          ></div>
        </div>
        <div
          @click="selectBonusQuests"
          class="w-1/2 cursor-pointer flex items-center justify-center pb-1 lg:pb-2 font-extrabold text-2xl relative"
        >
          <Typography
            size="main-l"
            :class="{ 'opacity-50 ': tabs.bonusQuests == false }"
            >Bonus Quests</Typography
          >
          <div
            :class="{
              'w-full h-1 bg-neutral-600  bottom-0 absolute': true,
              '!bg-primary h-1': tabs.bonusQuests == true,
            }"
          ></div>
        </div>
      </div>
      <StoryQuests v-if="tabs.storyQuests" />
      <BonusQuests
        v-if="tabs.bonusQuests"
        :bonusQuests="bonusQuests"
        @completeQuest="completeQuest"
        @claimQuest="handleDebouncedClick"
        :isSubmitting="isSubmitting"
      />
    </div>
    <!--
    <Modal
      v-if="claimedModal"
      :value="claimedModal.isOpen"
      @close="claimedModal.isOpen = false"
    >
      <div class="flex flex-col gap-6">
        <div class="flex gap-4 items-center justify-center">
          <span class="h-12 flex items-center -translate-y-2">
          <img src="~/assets/svg/troncos.svg" alt="woods" class="h-20 w-20" />
            <Typography size="main-xl" class="!text-[9rem]">{{
              claimedModal.logs
            }}</Typography>
          </span>
        </div>
        <Typography
          size="main-xl"
          class="text-center h-16 flex items-center justify-center"
        >
          Claimed!
        </Typography>

        <Typography class="text-center max-w-md">
          You successfull claimed {{ claimedModal.logs }} logs for Bonus
        </Typography>
        <Typography class="text-center max-w-md">
          Quest #{{ claimedModal.questId }}:{{ claimedModal.description }}
        </Typography>
        <button
          @click="claimedModal.isOpen = false"
          class="rounded bg-primary font-bold items-center justify-center flex"
        >
          <span class="h-12 flex justify-center items-center">
            <Typography size="main-l">Nice </Typography>
          </span>
        </button>
      </div>
    </Modal>
    -->
    <AlbarraModal />
    <div class="w-full absolute bottom-0 flex gap-2 justify-end mb-0">
      <typography
        @click="openTermsModal"
        class="mb-2 mr-4 !font-extralight !text-xs text-neutral-300 font-gotham cursor-pointer"
        >Terms & Conditions</typography
      >
      <typography
        @click="openPrivacyPolicy"
        class="mb-2 mr-4 !font-extralight !text-xs text-neutral-300 font-gotham cursor-pointer"
        >Privacy Policy</typography
      >
    </div>
    <MobileFullModal />
  </div>
</template>

<script setup>
import Typography from "../components/common/Typography.vue";
import AlbarraModal from "../components/modals/AlbarraModal.vue";
import { useAuthStore } from "../stores/useAuthStore";
import { cmsStore } from "../stores/cmsStore";
import { useModalsStore } from "../stores/useModalsStore";
import { useClaimsStore } from "../stores/useClaimsStore";
import { ref, onMounted, computed } from "vue";
import StoryQuests from "../components/story-quests.vue";
import BonusQuests from "../components/bonus-quest.vue";
import MobileFullModal from "../components/mobile-full-modal.vue";
import { useDebounce } from "../composables/useDebounce";
import { sleep } from "../utils/time.utils";

const { debounce } = useDebounce();
const authStoreService = useAuthStore();
const modalsStore = useModalsStore();
const cms = cmsStore();
const claimsStore = useClaimsStore();
const bonusQuests = computed(() => cms.getBonusQuests);

const isSubmitting = ref(false);

const tabs = ref({
  storyQuests: true,
  bonusQuests: false,
})

const openModal = (modalId) => {
  modalsStore.openModal(modalId);
}

function selectStoryQuests() {
  tabs.value.storyQuests = true;
  tabs.value.bonusQuests = false;
}

function selectBonusQuests() {
  tabs.value.storyQuests = false;
  tabs.value.bonusQuests = true;
}

async function checkIfUserFollowXAccount(bonus_id, twitter_account) {
  const apiLogicUrl = useRuntimeConfig().public.apiLogicUrl;
  const response = await $fetch(`${apiLogicUrl}/claims/follows/twitter`, {
    method: "POST",
    body: JSON.stringify({ bonus_id, twitter_account }),
    credentials: "include",
  });
  return response;
}

async function checkIfUserJoinedDiscordAndClaim(quest) {
  const discordUserId = authStoreService.discordId;
  const bonus_id = quest.id;

  if (!discordUserId) return false;
  const apiLogicUrl = useRuntimeConfig().public.apiLogicUrl;
  const response = await $fetch(`${apiLogicUrl}/claims/has-joined/discord`, {
    method: "POST",
    body: JSON.stringify({ bonus_id, discordUserId }),
    credentials: "include",
  });
  return response;
}

async function claimVisit(quest) {
  const THREE_SECONDS = 3000;
  await sleep(THREE_SECONDS);
  const bonus_id = quest.id;
  const apiLogicUrl = useRuntimeConfig().public.apiLogicUrl;
  const response = await $fetch(`${apiLogicUrl}/claims/visit`, {
    method: "POST",
    body: JSON.stringify({ bonus_id }),
    credentials: "include",
  });
  return response;
}

async function claimDoNotClick(quest) {
  const THREE_SECONDS = 3000;
  await sleep(THREE_SECONDS);
  const bonus_id = quest.id;
  const apiLogicUrl = useRuntimeConfig().public.apiLogicUrl;
  const response = await $fetch(`${apiLogicUrl}/claims/do-not-click`, {
    method: "POST",
    body: JSON.stringify({ bonus_id }),
    credentials: "include",
  });
  return response;
}

async function checkIfUserJoinedDiscord() {
  const discordUserId = authStoreService.discordId;

  const apiLogicUrl = useRuntimeConfig().public.apiLogicUrl;
  const response = await $fetch(
    `${apiLogicUrl}/discord/hasjoined/${discordUserId}`
  );
  return response;
}

async function completeQuest(quest) {
  quest.readyToClaim = true;
  if (quest.type === "follow_x") goToFollowLink(quest);
  else if (
    quest.type === "like_&_retweet_twitter" ||
    quest.type === "comment_twitter"
  ) {
    goToTweetLink(quest)
  }
  else if (quest.type === "follow_discord") {
    if (!authStoreService.isAuthenticated) {
      isSubmitting.value = false;
      return openModal("LOGIN");
    }
    quest.readyToClaim = false;
    const response = await checkIfUserJoinedDiscord(quest);
    if (response === true) {
      quest.readyToClaim = true;
    } else {
      quest.readyToClaim = false;
      openModal("JOIN_DISCORD");
    }
  }
  else if (quest.type === "quiz") {
    quest.readyToClaim = false;
    if (!authStoreService.isAuthenticated) {
      return openModal("LOGIN");
    }
    modalsStore.openModal("QUIZ_QUEST", { quest });
  }
  else if  (quest.type === "get_discord_role") {
    window.open(quest.values[0].discord_join_link, "_blank");
  } else if (quest.type === "visit") {
    window.open(quest.values[0].link, "_blank");
  } else if (quest.type === 'the_rail') {
    quest.readyToClaim = false;
    if (!authStoreService.isAuthenticated) {
      return openModal("LOGIN");
    }
    window.open(quest.values[0].link, "_blank");
    return modalsStore.openModal("THE_RAIL_QUEST", null, (success) => {
      if (success) {
        quest.readyToClaim = true;
      } else {
        quest.readyToClaim = false;
      }
    });
  } else if (quest.type === 'do_not_click') {
    quest.readyToClaim = false;
    if (!authStoreService.isAuthenticated) {
      isSubmitting.value = false;
      return openModal("LOGIN");
    }
    isSubmitting.value = true
    claimDoNotClick(quest)
      .then((response) => {
        if (response.code === 'bonus_quest_claimed') {
          quest.claim = true;
          quest.verify = false;
          quest.readyToClaim = false
        }
      })
      .then(() => {
        cms.updateNotifications()
        cms.loadBonusQuests().then(cms.loadCompletedBonusQuests)
      })
      .finally(() => {
        isSubmitting.value = false
      })
  }
}

function goToFollowLink(quest) {
  const value = quest.values.find((value) =>
    value.hasOwnProperty("twitter_follow_link")
  );
  if (value) {
    window.open(value.twitter_follow_link, "_blank");
    quest.readyToClaim = true;
  }
}

function goToTweetLink(quest) {
  const value = quest.values.find((value) =>
    value.hasOwnProperty("twitter_tweet_link")
  );
  if (value) {
    window.open(value.twitter_tweet_link, "_blank");
    quest.readyToClaim = true;
  }
}

function extractTwitterHandle(url) {
  const match = url.match(
    /(?:https?:\/\/)?(?:www\.)?(?:x\.com|twitter\.com)\/([a-zA-Z0-9_]+)/
  );
  return match ? match[1] : null;
}

const claimQuest = (quest) => {
  if (!authStoreService.isAuthenticated) {
    isSubmitting.value = false;
    return openModal("LOGIN");
  }
  if (quest.type === "follow_x") {
    const bonus_id = quest.id;
    const linkValue = quest.values.find((value) =>
      value.hasOwnProperty("twitter_follow_link")
    );
    const twitter_account = extractTwitterHandle(linkValue.twitter_follow_link);
    checkIfUserFollowXAccount(bonus_id, twitter_account)
      .then((response) => {
        if (response.code === 'user_not_following') {
          quest.readyToClaim = true
          quest.verify = false
          quest.claim = false
          openModal('USER_NOT_FOLLOW_TWITTER_ACCOUNT')
        } else if (response.code === 'user_already_claimed' || response.code === 'user_following') {
          quest.claim = true
          quest.verify = false
          quest.readyToClaim = false
        }
      })
      .then(() => {
        cms.loadUserLogs().then();
        cms.loadNotifications().then();
      })
      .catch((error) => {
        console.log(error);
        quest.readyToClaim = true;
        quest.claim = false;
      })
      .finally(() => {
        isSubmitting.value = false;
      });
  }
  else if (quest.type === "like_&_retweet_twitter") {
    claimsStore
      .requestClaimLikeAndRetweet({ bonus_id: quest.id })
      .then((response) => {
        if (response.code === "user_not_liked")
          return openModal("USER_NOT_LIKED");
        if (response.code === "user_not_retweeted")
          return openModal("USER_NOT_RETWEETED");
        if (response.code === "user_not_retweeted")
          return openModal("USER_NOT_RETWEETED");
        if (response.code === "bonus_already_claimed_verify") {
          quest.claim = false;
          quest.verify = true;
          quest.readyToClaim = false;
          return;
        }
        quest.claim = true;
        quest.verify = false;
        quest.readyToClaim = false;
      })
      .then(() => {
        cms.loadUserLogs().then();
        cms.loadNotifications().then();
      })
      .catch((error) => {
        console.log(error);
        quest.readyToClaim = true;
        quest.claim = false;
      })
      .finally(() => {
        isSubmitting.value = false;
      });
  }
  else if (quest.type === "comment_twitter") {
    claimsStore
      .requestClaimCommentTweet({ bonus_id: quest.id })
      .then((response) => {
        if (response.code === "user_not_commented")
          return openModal("USER_NOT_COMMENTED");
        quest.claim = true;
        quest.readyToClaim = false;
      })
      .then(() => {
        cms.loadUserLogs().then();
        cms.loadNotifications().then();
      })
      .catch((error) => {
        console.log(error);
        quest.readyToClaim = true;
        quest.claim = false;
      })
      .finally(() => {
        isSubmitting.value = false;
      });
  }
  else if (quest.type === "follow_discord") {
    checkIfUserJoinedDiscordAndClaim(quest)
      .then((response) => {
        if (response.follow) {
          quest.claim = true;
          quest.verify = false;
          quest.readyToClaim = false;
        } else {
          openModal("JOIN_DISCORD");
        }
      })
      .then(() => {
        cms.loadUserLogs().then();
        cms.loadNotifications().then();
        cms.loadBonusQuests().then(cms.loadCompletedBonusQuests);
      })
      .finally(() => {
        isSubmitting.value = false;
      });
  }
  else if (quest.type === "quiz") {
    modalsStore.openModal("QUIZ_QUEST");
    isSubmitting.value = false;
  }
  else if (quest.type === "get_discord_role") {
    const hasJoinDiscordCompleted = cms.hasJoinDiscordBonusQuestCompleted;
    const discordUserId = authStoreService.discordId;

    if (!hasJoinDiscordCompleted) {
      quest.readyToClaim = false;
      modalsStore.openModal("YOU_ARE_NOT_IN_DISCORD", null, enableSubmitButton);
      return;
    }
    if (!discordUserId) {
      quest.readyToClaim = false;
      modalsStore.openModal("JOIN_DISCORD", null, enableSubmitButton);
      return;
    }

    modalsStore.openModal("CLAIM_DISCORD_ROLES", { quest }, (payload) => {
      if (payload && payload.userHaveAllRoles) {
        quest.claim = true;
        quest.verify = false;
        quest.readyToClaim = false;
      } else if (payload && !payload.userHaveAllRoles) {
        quest.claim = false;
        quest.verify = false;
        quest.readyToClaim = false;
      } else if (!payload) {
        quest.claim = false;
        quest.verify = false;
        quest.readyToClaim = false;
      }
      enableSubmitButton()
    });
    quest.readyToClaim = true;
    
    isSubmitting.value = false;
  }
  else if (quest.type === "visit") {
    claimVisit(quest)
      .then((response) => {
        if (response.code === 'bonus_quest_claimed') {
          quest.claim = true;
          quest.verify = false;
          quest.readyToClaim = false;
        }
      })
      .then(() => {
        cms.updateNotifications();
        cms.loadBonusQuests().then(cms.loadCompletedBonusQuests);
      })
      .finally(() => {
        isSubmitting.value = false;
      });
  }
  else if (quest.type === "the_rail") {
    claimsStore.requestClaimTheRail({ bonus_id: quest.id })
      .then((response) => {
        if (response.code === 'invalid_code') {
          quest.claim = false;
          quest.verify = false;
          quest.readyToClaim = false;
          return;
        }
        quest.claim = true;
        quest.verify = false;
        quest.readyToClaim = false;
      })
      .then(() => {
        cms.loadUserLogs().then();
        cms.loadNotifications().then();
      })
      .catch((error) => {
        console.log(error);
        quest.readyToClaim = true;
        quest.claim = false;
      })
      .finally(() => {
        isSubmitting.value = false;
      });
  }
  cms.updateNotifications();
};

const handleDebouncedClick = debounce(async (quest) => {
  if (isSubmitting.value) return;
  isSubmitting.value = true;
  await claimQuest(quest);
}, 500);

function openTermsModal() {
  modalsStore.openModal("TERMS");
}

function openPrivacyPolicy() {
  modalsStore.openModal("PRIVACY");
}

function enableSubmitButton () {
  isSubmitting.value = false
}

onMounted(() => {
  modalsStore.openModal("WELCOME")
  if (authStoreService.isAuthenticated) {
    cms.loadBonusQuests().then(cms.loadCompletedBonusQuests)
    cms.loadUserLogs().then()
    cms.loadBadges().then()
  } else {
    cms.loadBonusQuests().then()
    cms.loadBadges().then()
  }
})
</script>
